export default __webpack_public_path__ + "testimonial-slider-section.png";